import React from 'react';

import { flagStyles } from '../settings';

const SvgCY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1272px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCY;
